'use client';

export { MarketingBrandProductsSection } from './MarketingBrandProductsSection';
export { MarketingCouponStrip, hasMarketingCouponList } from './MarketingCouponStrip';
export { MarketingFlashSaleSection } from './MarketingFlashSaleSection';
export { MarketingRankingSection } from './MarketingRankingSection';
export { MarketingSceneProductsSection } from './MarketingSceneProductsSection';
